<template>
    <span>
      <slot></slot>
    </span>
</template>

<script>
  export default {
    name: 'fit-text',
    props: {
      targetLineCount: {
        default: 1,
        type: Number,
      },
      unit: {
        default: 'px',
        type: String,
      },
      min: {
        default: 9,
        type: Number,
      },
      max: {
        default: 16,
        type: Number,
      },
      changed: {
        type: Function,
      },
    },
    data() {
      return {
        observer: null,
      };
    },
    methods: {
      calculate() {
        const element = this.$el;
        element.style.display = 'inline-block';
        element.style.lineHeight = '1px';
        let fontSize = this.max;
        const stepSize = (this.unit === 'px') ? 1 : 0.05;
        element.style.fontSize = fontSize + this.unit;
        while (element.offsetHeight > this.targetLineCount && fontSize > this.min) {
          fontSize -= stepSize;
          element.style.fontSize = fontSize + this.unit;
          this.changed({ fontSize });
        }
        element.style.display = null;
        element.style.lineHeight = null;
      },
    },
    mounted() {
      this.calculate();
      if ('MutationObserver' in window && this.observer === null) {
        this.observer = new MutationObserver(this.calculate);
        this.observer.observe(
          this.$el,
          { subtree: true, characterData: true },
        );
      }
    },
    beforeDestroy() {
      this.observer.disconnect();
    },
  };
</script>



// WEBPACK FOOTER //
// FitText.vue?7edf8658